import script from "./Blueriqpage.vue?vue&type=script&setup=true&lang=js"
export * from "./Blueriqpage.vue?vue&type=script&setup=true&lang=js"

import "./Blueriqpage.vue?vue&type=style&index=0&id=4d0c8472&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d0c8472"]])

export default __exports__